import httpClient from '@/lib/httpClient'
import { useQuery } from '@tanstack/react-query'

export default function useGetSubscription({ teamId }: { teamId: string }) {
  const fetchData = async () => {
    const response = await httpClient.get(`team/team/subscription`, {
      headers: {
        'X-Team': teamId,
      },
    })

    return response.data
  }

  return useQuery({
    queryKey: ['subscription', teamId],
    queryFn: fetchData,
    staleTime: Infinity,
    enabled: !!teamId,
  })
}
